import { Moment } from 'moment';

import { momentOrNull } from 'jsx/utils/dateUtils';

import { PrescriptionType } from '../types';
import FormulationModel from './formulationModel';

export default class PrescriptionModel {
  id: number;

  prescribedAt: Moment | null;

  formulation: FormulationModel;

  prescriptionPlanId: number;

  isVoid: boolean;

  isExpired: boolean;

  isPrescribed: boolean;

  isValid: boolean;

  canBeVoided: boolean;

  voidedAt: Moment | null;

  productId: number;

  constructor(data: PrescriptionType) {
    this.id = data.id;
    this.prescribedAt = momentOrNull(data.prescribedAt);
    this.formulation = new FormulationModel(data.formulation);
    this.prescriptionPlanId = data.prescriptionPlanId;
    this.isVoid = data.isVoid;
    this.isExpired = data.isExpired;
    this.isPrescribed = data.isPrescribed;
    this.isValid = data.isValid;
    this.canBeVoided = data.canBeVoided;
    this.voidedAt = momentOrNull(data.voidedAt);
    this.productId = data.productId;
  }
}
